import { Component } from 'react';
import { AuthenticationDetails, CognitoUserPool, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import AWS from 'aws-sdk';
import Config from 'src/config.json';
/*
  Cognito認証関係のメソッドを使いやすくまとめたクラス
*/
class Cognito extends Component {

  /*
    ユーザプール取得
    Param
      userPoolId  ユーザプールID
      clientId  クライアントID
    return
      ユーザプール
  */
  static getUserPool(userPoolId, clientId) {

    const userPoolData = {
      UserPoolId: userPoolId,
      ClientId: clientId,
    };

    let userPool = new CognitoUserPool(userPoolData);

    return userPool;
  }

  /*
    認証情報取得
    Param
      userName  ユーザ名
      password  パスワード
    return
      認証情報
  */
  static getAuthenticationDetails(userName, password) {

    const authenticationData = {
      Username: userName,
      Password: password
    };

    let authenticationDetails = new AuthenticationDetails(authenticationData);

    return authenticationDetails;
  }

  /*
    認証チェック
    return
      認証済みか否か
  */
  static signInCheck() {

    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;

    let userPool = this.getUserPool(userPoolId, clientId);
    let cognitoUser = userPool.getCurrentUser();

    if (!cognitoUser) {
      return false;
    }
    else {
      return true;
    }
  }

  /*
    ユーザのSubを取得
  */
  static getCognitoUserSub() {
    let _this = this;
    _this.sub = {};

    let cognitoUser = this.getCognitoUser();
    cognitoUser.getSession(function (err, result) {
      if (err) {
        console.log(err);
      }
      else {
        _this.sub = cognitoUser.signInUserSession.accessToken.payload["sub"];
      }
    });
    return _this.sub;
  }

  /*
    ログイン中ユーザ取得
  */
  static getCognitoUser() {
    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;

    let userPool = this.getUserPool(userPoolId, clientId);
    let cognitoUser = userPool.getCurrentUser();

    return cognitoUser;
  }


  /*
    サインアップ承認
    Param
      userName ユーザ名
      verificationCode 認証コード
  */
  static signUpVerification(userName, verificationCode){
    let _this = this;

    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;

    // ユーザプール取得
    let userPool = this.getUserPool(userPoolId, clientId);
    const cognitoUser = new CognitoUser({
      Username: userName,
      Pool: userPool
    })

    return new Promise(function (resolve, reject){
      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, waitSeconds * 1000)
        });
      }
      cognitoUser.confirmRegistration(verificationCode, true, (err, result) => {
        if(err){
          console.log(err)
          reject(err)
        }
        else{
          sleep(1).then(() => {
            console.log("verification ok!")
            resolve(result);
          }).catch((error) => {
            console.log("verification failed!")
            reject(err)
            console.log(error);
          });
        }
      });
    })

 }

  /*
    サインアップ
    Param
      userName  ユーザ名
      email     メールアドレス
      password  パスワード
  */
  static signUp(userName, email, password){
    // 既にログインしているユーザがいる場合は、そのユーザをサインアウトさせる
    if (this.signInCheck()) {
    this.signOut();
    }
    let _this = this;

    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;
    
    // ユーザプール取得
    let userPool = this.getUserPool(userPoolId, clientId);

    const attributeList = [
      new CognitoUserAttribute(
        {
          Name: 'email',
          Value: email
        },
      )
    ]

    return new Promise(function (resolve, reject){
      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, waitSeconds * 1000)
        });
      }
      userPool.signUp(userName, password, attributeList, [], (err, result) =>{
        if(err){
          console.log(err)
          reject(err)
        }
        else{
          sleep(1).then(() => {
            resolve(result);
          }).catch((error) => {
            reject(err)
            console.log(error);
          });
        }
      });
    });
  }

  /*
    サインイン
    Param
      userName  ユーザ名
      password  パスワード
  */
  static signIn(userName, password) {

    // 既にログインしているユーザがいる場合は、そのユーザをサインアウトさせる
    if (this.signInCheck()) {
      this.signOut();
    }

    let _this = this;

    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;

    // ユーザプール取得
    let userPool = this.getUserPool(userPoolId, clientId);

    const cognitoUserData = {
      Username: userName,
      Pool: userPool,
    };

    // ユーザプールから入力値のユーザを取得
    let cognitoUser = new CognitoUser(cognitoUserData);

    let authenticationDetails = this.getAuthenticationDetails(userName, password);

    // 認証処理
    return new Promise(function (resolve, reject) {

      const sleep = (waitSeconds) => {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, waitSeconds * 1000)
        })
      }

      cognitoUser.authenticateUser(authenticationDetails, {
        // 成功
        onSuccess: function (result) {
          // クッキーに認証フラグを追加
          document.cookie = Config.COOKIE.AUTH_KEY_NAME + '=true; path=/; max-age=600';

          sleep(1).then(() => {
            _this.setCredentials(cognitoUser);
            resolve(result);
          }).catch((error) => {
            console.log(error);
          });
        },
        //失敗
        onFailure: function (err) {
          reject(err);
        },
        // 新規パスワード登録
        newPasswordRequired: function (userAttributes, requiredAttributes) {
          resolve(
            {
              cognitoUser: cognitoUser,
              userAttributes: userAttributes,
            }
          );
        }
      });
    });
  }

  /*
    サインアウト
  */
  static signOut() {
    let cognitoUser = Cognito.getCognitoUser();

    this.setCredentials(cognitoUser);

    // 資格情報をクリア
    if (AWS.config.credentials) {
      AWS.config.credentials.clearCachedId();
    }

    if (cognitoUser !== null) {
      cognitoUser.signOut()
    } else {
      return;
    }

    // クッキーの認証フラグを削除
    let date = new Date();
    date.setTime(date.getTime() - 1);
    document.cookie = Config.COOKIE.AUTH_KEY_NAME + '=; expires=' + date.toUTCString();

    // 言語切り替え情報を一度避難
    let lng = localStorage.getItem('lng')
    
    localStorage.clear();

    // 言語切り替え情報が消えてしまっているので、再セット
    localStorage.setItem('lng',lng)
  }

  // パスワードリセット用の確認コードを送信
  static resetPassword(userName){
    //
    // 元の書き方の方が読みやすい？？？？
    //

    // ユーザプールの取得
    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;
    let userPool = this.getUserPool(userPoolId, clientId);

    // 引数のユーザのCognitoインスタンスを取得
    let cogitoUserData = {
      Username: userName,
      Pool: userPool
    };
    let cognitoUser = new CognitoUser(cogitoUserData);


    // 確認コードを送信する処理
    return new Promise(function (resolve, reject){

      cognitoUser.forgotPassword({
        onSuccess: (result) => {
          resolve(result);
          console.log(result);
        },
        onFailure: (err) => {
          // 送信失敗時の処理
          reject(err);
          console.log(err);
        }
      });
    })


  }

  // パスワードリセット後に、新しいパスワードと確認コードを設定する
  static confirmResetPassword(userName, newPassword, verificationCode){
    // ユーザプールの取得
    let userPoolId = Config.COGNITO.USER_POOL_ID;
    let clientId = Config.COGNITO.CLIENT_ID;
    let userPool = this.getUserPool(userPoolId, clientId);

    // 引数のユーザのCognitoインスタンスを取得
    let cogitoUserData = {
      Username: userName,
      Pool: userPool
    };
    let cognitoUser = new CognitoUser(cogitoUserData);

    return new Promise(function(resolve, reject){
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess: (result) => {
          resolve(result);
        },
        onFailure: (err) => {
          // 承認失敗時の処理
          reject(err);
        }
      });
    });
  }

  /*
    資格情報セット
  */
  static setCredentials(cognitoUser) {

    return new Promise(function (resolve, reject) {

      // セッション取得
      let getSessionPromise = new Promise(function (resolve, reject) {
        cognitoUser.getSession(function (err, sessresult) {
          if (err) {
            reject(err);
          }
          resolve(sessresult);
        });
      });

      getSessionPromise.then(function (sessresult) {
        // AWS Credentialの初期化
        let logins = "cognito-idp." + Config.AWS.REGION + ".amazonaws.com/" + Config.COGNITO.USER_POOL_ID;
        let cognitoParams = {
          IdentityPoolId: Config.COGNITO.IDENTITY_POOL_ID,
          Logins: {
            [logins]: sessresult.getIdToken().getJwtToken()
          },
          LoginId: cognitoUser.username,
        };
        AWS.config.region = Config.AWS.REGION;
        AWS.config.credentials = new AWS.CognitoIdentityCredentials(cognitoParams);
        resolve();
      }).catch(function (err) {
        console.log(err);
        reject(err);
      });
    });
  }
}

export default Cognito;



// WEBPACK FOOTER //
// ./src/js/Cognito.js